import styled, { css } from 'styled-components';

import { breakPoint } from '@r1-frontend/ui-react/assets/js/constants';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const LinkStyle = css`
    > a {    
        ${FONTS.S};
        color: ${COLORS.LabelsBg_5};
        border-bottom: 1px dotted ${COLORS.LabelsBg_5};
    }
`;

export const ListItem = styled.li`
    display: flex;
    flex-wrap: nowrap;
    margin-top: 30px;
    align-content: flex-start;
    align-items: flex-start;
`;

export const ListIcon = styled.div`
    font-family: 'icomoon',serif;
    font-size: 50px;
    min-width: 90px;
    height: 50px;
            
    @media(${breakPoint(320)}) {
        font-size: 32px;
        min-width: 50px;
    }
`;

export const ListItemRight = styled.div`
    flex-direction: column;
`;

export const ListTitle = styled.h3`
    ${FONTS.H2}
    
   @media(${breakPoint(320)}) {
        ${FONTS.H3}
    }
`;

export const ListDescription = styled.span`
    margin-top: 10px;
    ${LinkStyle};   
    
    @media(${breakPoint(320)}) {
        width: 100%;
        line-height: 25px;
    }
`;

export const Information = styled.p`
    display: block;
    ${LinkStyle};   
`;
